import PageHeader from "components/Page/PageHeader";
import { useMemo, useState } from "react";
import useDownloadRenderedPdf from "infra/helpers/useDownloadRenderedPdf";
import PDFRelatorioInadimplentes from "../PDFRelatorio";
import moment from "moment";
import useRelatorioInadimplentesPdf from "core/features/relatorios/hooks/useRelatorioInadimplentesPdf";
import useFiltroRelatorioInadimplentes from "./../../hooks/useFiltroRelatorioInadimplentes";
import InadimplentesContent from "./../InadimplentesContent/index";
import useRelatorioInadimplentesInfiniteScroll from "core/features/relatorios/hooks/useRelatorioInadimplentesInfiniteScroll";
import useRelatorioInadimplentesDashboard from "core/features/relatorios/hooks/useRelatorioInadimplentesDashboard";
import {
  RelatorioInadimplentesItem,
  fieldsRelatorioInadimplentesColumns,
  RelatorioInadimplentesFields,
} from "core/features/relatorios/typings";
import { exportExcelRelatorioInadimplentes } from "./../util/helper";
import { AssinaturasItem } from "components/Relatorio/FormAssinaturas";
import ModalSelectFieldsRelatorio from "components/ModalSelectFieldsRelatorio";
import { RelatorioInadimplentesEvents } from "core/features/relatorios/enums/events";
import { trackEvent } from "infra/helpers/event";

function ListagemInadimplentes() {
  const [exportType, setExportType] = useState<
    { type: "pdf" | "excel" } | undefined
  >();

  const { filtro, onChangeFiltro, onResetFiltro } =
    useFiltroRelatorioInadimplentes();

  const { data: dashboard, isLoading: isLoadingDashboard } =
    useRelatorioInadimplentesDashboard(filtro);

  const {
    data: dataInadimplentes,
    isLoading,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useRelatorioInadimplentesInfiniteScroll(filtro);

  const {
    refetch,
    isLoading: isLoadingPdf,
    isFetching: isFetchingPdf,
  } = useRelatorioInadimplentesPdf(filtro);

  const { onDownload: onExportPdf } = useDownloadRenderedPdf({
    fileName: `Relatório de Inadimplentes - ${moment().format("DD_MM_YYYY")}`,
    Component: PDFRelatorioInadimplentes,
    loading: isLoadingPdf || isFetchingPdf,
  });

  const _onExportPdf = (
    selectedFields?: RelatorioInadimplentesFields[],
    assinaturas?: AssinaturasItem[]
  ) => {
    trackEvent(RelatorioInadimplentesEvents.ExportarPDF);
    refetch().then(({ data: dataExport }) => {
      if (dataExport) {
        onExportPdf({ data: { ...dataExport, assinaturas }, selectedFields });
      }
    });
  };

  const onExportExcel = (selectedFields?: RelatorioInadimplentesFields[]) => {
    trackEvent(RelatorioInadimplentesEvents.ExportarExcel);
    refetch().then(({ data: dataExport }) => {
      if (dataExport) {
        exportExcelRelatorioInadimplentes({
          data: dataExport,
          selectedFields,
        });
      }
    });
  };

  const data = useMemo(() => {
    return (
      dataInadimplentes?.pages.reduce(
        (agg: RelatorioInadimplentesItem[], item) =>
          agg.concat(item.items ?? []),
        []
      ) ?? []
    );
  }, [dataInadimplentes]);

  return (
    <>
      <PageHeader justifyContent="space-between" title="Inadimplentes" />

      <InadimplentesContent
        onExportPdf={() => setExportType({ type: "pdf" })}
        onExportExcel={() => setExportType({ type: "excel" })}
        dashboard={dashboard}
        isLoadingDashboard={isLoadingDashboard}
        refetch={refetch}
        data={data}
        filtro={filtro}
        onChangeFiltro={onChangeFiltro}
        onResetFiltro={onResetFiltro}
        isLoading={isLoading}
        fetchNextPage={fetchNextPage}
        hasNextPage={!!hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />

      <ModalSelectFieldsRelatorio
        visible={!!exportType?.type}
        onClose={() => setExportType(undefined)}
        onSubmit={({ fields, assinaturas }) => {
          exportType?.type === "pdf"
            ? _onExportPdf(fields, assinaturas)
            : onExportExcel(fields);

          setExportType(undefined);
        }}
        fields={fieldsRelatorioInadimplentesColumns}
      />
    </>
  );
}

export default ListagemInadimplentes;
